import { useState, useEffect } from 'react';
import { getParameter } from '@hotjar/insights-common/lib/url';

export const useQueryParameter = (key: string): string | undefined => {
  const [value, setValue] = useState(getParameter(window.location.href, key) || undefined);

  useEffect(() => {
    setValue(getParameter(window.location.href, key));
  }, [setValue, key]);

  return value;
};
